import React from "react";
import { IconButton } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export default function CloseButton({ ...props }) {
  return (
    <IconButton edge="start" color="inherit" aria-label="close" {...props}>
      <CloseIcon fontSize="medium" sx={{ color: "primary.light" }} />
    </IconButton>
  );
}
